<template>
  <Popup
    :visible="visible"
    title="礼品卡核销"
    :tips="tips"
    @update:visible="handleVisibleUpdate"
    @on-hide="handleHide"
  >
    <div class="write-off-form">
      <input
        v-model.trim="amount"
        type="number"
        class="write-off-form__field write-off-form__input"
        placeholder="请输入核销金额（元）"
      />
      <p class="write-off-form__cost-tip">核销成本{{ costText }}元</p>

      <input
        v-model.trim="bizNo"
        type="text"
        :maxlength="50"
        class="write-off-form__field write-off-form__input"
        placeholder="请填写业务单号（非必填）"
      />

      <div
        class="write-off-form__field write-off-form__select"
        :class="{ 'is-active': showItemPicker }"
        @click="openItemPicker"
      >
        <span :class="['write-off-form__select-text', { 'is-placeholder': !selectedItemNames }]">
          {{ selectedItemNames || '请选择使用项目（可多选）' }}
        </span>
        <i class="write-off-form__select-arrow"></i>
      </div>

      <textarea
        v-model.trim="remark"
        class="write-off-form__field write-off-form__textarea"
        :maxlength="remarkMax"
        placeholder="请填写核销备注"
        rows="4"
      ></textarea>

      <button
        class="write-off-form__submit"
        :disabled="loading"
        @click="handleConfirm"
      >
        {{ loading ? '提交中...' : '确认' }}
      </button>
    </div>

    <Popup
      :visible.sync="showItemPicker"
      title="请选择使用项目"
      tips="可多选"
    >
      <div class="write-off-form__picker">
        <div v-if="!itemOptions.length" class="write-off-form__picker-empty">
          暂无可选项目
        </div>
        <ul v-else class="write-off-form__picker-list">
          <li
            v-for="opt in itemOptions"
            :key="opt.name"
            class="write-off-form__picker-item"
            @click="toggleItem(opt.name)"
          >
            <span class="write-off-form__picker-label">{{ opt.display_name }}</span>
            <i
              class="write-off-form__picker-check"
              :class="{ 'is-checked': pickerSelected.includes(opt.name) }"
            ></i>
          </li>
        </ul>
        <div class="write-off-form__picker-actions">
          <button class="write-off-form__picker-btn write-off-form__picker-btn--cancel" @click="cancelPicker">取消</button>
          <button class="write-off-form__picker-btn write-off-form__picker-btn--confirm" @click="confirmPicker">确定</button>
        </div>
      </div>
    </Popup>
  </Popup>
</template>

<script>
import Popup from '@/components/Popup/Index.vue'

export default {
  name: 'BizGiftCardWriteOff',
  components: {
    Popup
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    // 核销成本费率：cost = amount * costRate（amount 单位：元）
    costRate: {
      type: Number,
      default: 0
    },
    remarkMax: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      amount: '',
      bizNo: '',
      selectedProjects: [],
      remark: '',
      showItemPicker: false,
      pickerSelected: [],
      itemOptions: []
    }
  },
  computed: {
    costText() {
      const value = parseFloat(this.amount)
      if (!this.costRate || !value || isNaN(value) || value <= 0) {
        return '0.00'
      }
      return (value * this.costRate).toFixed(2)
    },
    selectedItemNames() {
      if (!this.selectedProjects.length) return ''
      const map = new Map(this.itemOptions.map(o => [o.name, o.display_name]))
      return this.selectedProjects
        .map(name => map.get(name))
        .filter(Boolean)
        .join('、')
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.resetForm()
        this.fetchItemOptions()
      }
    }
  },
  methods: {
    resetForm() {
      this.amount = ''
      this.bizNo = ''
      this.selectedProjects = []
      this.remark = ''
      this.showItemPicker = false
      this.pickerSelected = []
    },
    fetchItemOptions() {
      this.$rest.coupon.getWriteOffProjects().then(res => {
        if (res && res.code === 0) {
          const { write_off_projects = [] } = res.data || {}
          this.itemOptions = write_off_projects
        } else if (res) {
          this.showToast(res.message)
          this.itemOptions = []
        }
      }).catch(() => {
        this.itemOptions = []
      })
    },
    handleVisibleUpdate(val) {
      this.$emit('update:visible', val)
    },
    handleHide() {
      this.$emit('on-cancel')
    },
    openItemPicker() {
      this.pickerSelected = [...this.selectedProjects]
      this.showItemPicker = true
    },
    toggleItem(name) {
      const idx = this.pickerSelected.indexOf(name)
      if (idx >= 0) {
        this.pickerSelected.splice(idx, 1)
      } else {
        this.pickerSelected.push(name)
      }
    },
    cancelPicker() {
      this.showItemPicker = false
    },
    confirmPicker() {
      this.selectedProjects = [...this.pickerSelected]
      this.showItemPicker = false
    },
    handleConfirm() {
      if (this.loading) return
      this.$emit('on-confirm', {
        amount: this.amount,
        bizNo: this.bizNo,
        projects: [...this.selectedProjects],
        remark: this.remark
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../stylesheets/components/write-off-form.less';

// 礼品卡专属：核销成本提示
.write-off-form__cost-tip {
  margin: 8/@w2 0 0;
  font-size: 24/@w2;
  line-height: 34/@w2;
  color: #999;
}
</style>
